module.exports = __webpack_public_path__ + "f253d837eb17201b8864bc4d9ff16351.svg";